import { Box, Tooltip } from '@mui/material';
import { DataCellProps } from '../types';

const maxLen = 30;

export const TeamsV2TeamNameCell = ({ team }: DataCellProps) => {
  const name = team.name || '';
  const needsTruncate = name.length > maxLen;
  const display = needsTruncate ? `${name.slice(0, maxLen)}...` : name;
  const content = <Box>{display}</Box>;
  return needsTruncate ? (
    <Tooltip title={name}>
      <span>{content}</span>
    </Tooltip>
  ) : (
    content
  );
};

export default TeamsV2TeamNameCell;
